var m = require('mithril');
var prop = require('mithril/stream');
var Model = require('../libs/Model');
var key = require('../libs/keybindings');
var buttonElement = require('../components/button');
var formGroup = require('../components/formGroup');
var ToggleSwitch = require('../components/toggleSwitch');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var userPassword = require('./models/userPassword');
var userAdmin = require('./models/userAdmin');
var userProfileModel = require('../../../../models/users/user');
var passwordPolicy = require('../../../../models/users/passwordPolicy');
var userProfile = Object.assign({}, userProfileModel, Model);
var auth = require('../auth/models/session');
var heading = require('../components/heading');
var tabs = require('../components/tabs');
var flash = require('../components/flash');
var profileGroups = require('./profileGroups');

userProfile.fields = Object.assign({}, userProfileModel.fields);
delete userProfile.fields.username;
delete userProfile.fields.useUsaUnits;
delete userProfile.fields.homeLocation;
delete userProfile.fields.homeDashboard;

var page = {};
var successFlashTimeoutMs = 3000;

function renderProfileTextField(fieldName, label) {
  var inputId = 'profile-' + fieldName + '-input';
  return m(formGroup, [
    m('label', { for: inputId }, label),
    m('input.form-control', {
      id: inputId,
      type: 'text',
      autocomplete: 'off',
      spellcheck: false,
      autocorrect: 'off',
      value: userProfile.form[fieldName]() || '',
      oninput: function (ev) {
        userProfile.form[fieldName](ev.target.value);
      }
    })
  ]);
}

function setNumericBoolean(formProp, enabled) {
  formProp(enabled ? 1 : 0);
}

function renderProfileSwitchField(fieldName, label) {
  var inputId = 'profile-' + fieldName + '-toggle';
  var enabled = normalizeBoolean(userProfile.form[fieldName](), false);
  return m(formGroup, { class: 'mt3 mb3' }, [
    m('div.flex.items-center.justify-between', [
      m('label', { for: inputId }, label),
      m(ToggleSwitch, {
        id: inputId,
        checked: enabled,
        ariaLabel: label,
        onchange: function () {
          setNumericBoolean(userProfile.form[fieldName], !enabled);
        }
      })
    ])
  ]);
}

userProfile.view = function () {
  return m('form', { role: 'form' }, [
    userProfile.errorView(),
    renderProfileTextField('firstName', 'First Name'),
    renderProfileTextField('lastName', 'Last Name'),
    renderProfileTextField('email', 'Email'),
    renderProfileTextField('sms', 'SMS'),
    renderProfileSwitchField('typewriterEffect', 'Typewriter Animation')
  ]);
};

function normalizeRid(rid) {
  return rid ? rid.toString().replace(/^#/, '') : '';
}

function normalizeBoolean(value, fallback) {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    var trimmed = value.trim().toLowerCase();
    if (['true', '1', 'yes', 'on'].includes(trimmed)) return true;
    if (['false', '0', 'no', 'off'].includes(trimmed)) return false;
  }
  return fallback;
}

function formatNotificationPreferenceValue(value) {
  return normalizeBoolean(value, true);
}

function buildNotificationPrefsPayload() {
  return {
    commandNotificationsEnabled: formatNotificationPreferenceValue(userProfile.form.commandNotificationsEnabled()),
    commentNotificationsEnabled: formatNotificationPreferenceValue(userProfile.form.commentNotificationsEnabled())
  };
}

function applyNotificationPrefs(ctrl, payload) {
  ctrl.user.commandNotificationsEnabled = payload.commandNotificationsEnabled;
  ctrl.user.commentNotificationsEnabled = payload.commentNotificationsEnabled;
  if (auth.user() && normalizeRid(auth.user()['@rid']) === ctrl.profileRid) {
    auth.user(Object.assign({}, auth.user(), payload));
  }
}

function formatNotificationPrefsError(err) {
  return (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to save notification preferences');
}

function clearFlashTimeout(ctrl, timeoutKey) {
  if (ctrl[timeoutKey]) {
    clearTimeout(ctrl[timeoutKey]);
    ctrl[timeoutKey] = null;
  }
}

function autoClearFlash(ctrl, propName, timeoutKey) {
  clearFlashTimeout(ctrl, timeoutKey);
  ctrl[timeoutKey] = setTimeout(function () {
    ctrl[propName]([]);
    ctrl[timeoutKey] = null;
    m.redraw();
  }, successFlashTimeoutMs);
}

function clearProfileSuccessFlash(ctrl) {
  clearFlashTimeout(ctrl, 'successFlashTimeout');
  ctrl.successFlash([]);
}

function showProfileSuccessFlash(ctrl, messages) {
  ctrl.successFlash(messages);
  autoClearFlash(ctrl, 'successFlash', 'successFlashTimeout');
}

function clearNotificationPrefsFlash(ctrl) {
  clearFlashTimeout(ctrl, 'notificationPrefsMessageTimeout');
  ctrl.notificationPrefsMessage([]);
  ctrl.notificationPrefsError([]);
}

function showNotificationPrefsSuccess(ctrl) {
  ctrl.notificationPrefsError([]);
  ctrl.notificationPrefsMessage(['Saved notification preferences']);
  autoClearFlash(ctrl, 'notificationPrefsMessage', 'notificationPrefsMessageTimeout');
}

function showNotificationPrefsError(ctrl, err) {
  clearFlashTimeout(ctrl, 'notificationPrefsMessageTimeout');
  ctrl.notificationPrefsMessage([]);
  ctrl.notificationPrefsError([formatNotificationPrefsError(err)]);
}

function flushNotificationPrefsQueue(ctrl) {
  if (ctrl.notificationPrefsSaving() || !ctrl.notificationPrefsQueue.length) return;
  var payload = ctrl.notificationPrefsQueue.shift();
  clearNotificationPrefsFlash(ctrl);
  ctrl.notificationPrefsSaving(true);
  loaders.requestWithLoader({
    loader: 'submit',
    method: 'PUT',
    url: '/api/v1/user/' + ctrl.profileRid,
    body: payload
  })
  .then(function () {
    applyNotificationPrefs(ctrl, payload);
    showNotificationPrefsSuccess(ctrl);
  })
  .catch(function (err) {
    showNotificationPrefsError(ctrl, err);
  })
  .finally(function () {
    ctrl.notificationPrefsSaving(false);
    if (ctrl.notificationPrefsQueue.length) {
      flushNotificationPrefsQueue(ctrl);
    }
    m.redraw();
  });
}

function queueNotificationPrefsSave(ctrl) {
  ctrl.notificationPrefsQueue.push(buildNotificationPrefsPayload());
  flushNotificationPrefsQueue(ctrl);
}

page.oninit = function () {
  var ctrl = this;
  //ctrl.user = prop({});
  header.vm.activeTab('Profile');
  document.title = 'nimrod | Profile';
  ctrl.newNode = prop(false);
  ctrl.successFlash = prop([]);
  ctrl.notificationPrefsMessage = prop([]);
  ctrl.notificationPrefsError = prop([]);
  ctrl.notificationPrefsSaving = prop(false);
  ctrl.notificationPrefsQueue = [];
  ctrl.successFlashTimeout = null;
  ctrl.notificationPrefsMessageTimeout = null;
  ctrl.currentUserRid = auth.user() && auth.user()['@rid'] ? auth.user()['@rid'].toString() : '';
  var requestedRid = normalizeRid(m.route.param('rid'));
  var loggedInRid = normalizeRid(ctrl.currentUserRid);

  ctrl.profileRid = loggedInRid;

  if (!ctrl.profileRid) {
    ctrl.successFlash(['Unable to load profile']);
    return;
  }

  // Prevent navigating to other user profiles
  if (requestedRid && requestedRid !== ctrl.profileRid) {
    m.route.set('/profile/' + ctrl.profileRid, undefined, {replace: true});
  }

  ctrl.init = function () {
    loaders.requestWithLoader({
      method : 'GET',
      url: '/api/v1/user/' + ctrl.profileRid
    })
    .then(function (record) {
      userProfile.initForm(record);
      userPassword.initForm(record);
      userAdmin.initForm(record);
      ctrl.user = record;
      if (normalizeRid(ctrl.currentUserRid) === ctrl.profileRid && ctrl.currentUserRid) {
        auth.getUser(ctrl.currentUserRid);
      }
      ctrl.newNode(true);
    });
  }
  ctrl.init();
  key.setScope('profile');
};

page.onremove = function () {
  clearFlashTimeout(this, 'successFlashTimeout');
  clearFlashTimeout(this, 'notificationPrefsMessageTimeout');
  key.deleteScope('profile');
  key.setScope('home');
}

function isPasswordProfileForm(form) {
  return !!(form && form.form && form.form.password && form.form.confirmPassword);
}

function submitProfileForm(form, ctrl, ev) {
  if (ev && typeof ev.preventDefault === 'function') ev.preventDefault();
  return saveProfile(form, ctrl);
}

function handleProfileEnter(form, ctrl, ev) {
  if (!ev || ev.key !== 'Enter') return;

  var target = ev.target || ev.srcElement;
  if (!target || target.tagName !== 'INPUT') return;

  ev.preventDefault();

  if (isPasswordProfileForm(form) && target.id === 'password-input') {
    var confirmPasswordInput = target.form && target.form.querySelector('#confirm-password-input');
    if (confirmPasswordInput) confirmPasswordInput.focus();
    return;
  }

  return submitProfileForm(form, ctrl, ev);
}

function profileWrap (form, ctrl) {
  return {
    view: function () { 
      return m('div', {
        oninput: function () { clearProfileSuccessFlash(ctrl); },
        onsubmit: submitProfileForm.bind(null, form, ctrl),
        onkeydown: handleProfileEnter.bind(null, form, ctrl)
      }, [
        m(form),
        m(buttonElement, {
          label: 'Submit',
          func: submitProfileForm.bind(null, form, ctrl),
          class: 'green mt4'
        })
      ]);
    }
  }
};

function groupsWrap (ctrl) {
  return {
    view: function () { 
      var eventNotificationsEnabled = normalizeBoolean(ctrl.user.eventNotificationsEnabled, true);
      var commandNotificationsEnabled = formatNotificationPreferenceValue(userProfile.form.commandNotificationsEnabled());
      var commentNotificationsEnabled = formatNotificationPreferenceValue(userProfile.form.commentNotificationsEnabled());
      return m('div', [
        eventNotificationsEnabled ? m('div.mb3', [
          m('h4.mt0', 'Notification Preferences'),
          ctrl.notificationPrefsError() && ctrl.notificationPrefsError().length
            ? m(flash, { items: ctrl.notificationPrefsError(), bg: 'bg-red' })
            : null,
          ctrl.notificationPrefsMessage() && ctrl.notificationPrefsMessage().length
            ? m(flash, { items: ctrl.notificationPrefsMessage(), bg: 'bg-green' })
            : null,
          m('div.mb2', [
            m('div.flex.items-center.justify-between', [
              m('span', 'Command Notifications'),
              m(ToggleSwitch, {
                id: 'command-notifications-toggle',
                checked: commandNotificationsEnabled,
                ariaLabel: 'Command notifications',
                onchange: function () {
                  clearNotificationPrefsFlash(ctrl);
                  userProfile.form.commandNotificationsEnabled(!commandNotificationsEnabled);
                  queueNotificationPrefsSave(ctrl);
                }
              })
            ]),
            m('div.f6.gray.mt1', 'Receive notifications when someone sends a write command - like a setpoint or override.')
          ]),
          m('div.mb2', [
            m('div.flex.items-center.justify-between', [
              m('span', 'Comment Notifications'),
              m(ToggleSwitch, {
                id: 'comment-notifications-toggle',
                checked: commentNotificationsEnabled,
                ariaLabel: 'Comment notifications',
                onchange: function () {
                  clearNotificationPrefsFlash(ctrl);
                  userProfile.form.commentNotificationsEnabled(!commentNotificationsEnabled);
                  queueNotificationPrefsSave(ctrl);
                }
              })
            ]),
            m('div.f6.gray.mt1', 'Receive notifications when someone makes a comment.')
          ]),
        ]) : null,
        m(profileGroups, {
          groups: ctrl.user.groups,
          newNode: ctrl.newNode,
          onPreferenceSaving: function () {
            clearNotificationPrefsFlash(ctrl);
          },
          onPreferenceSave: function () {
            showNotificationPrefsSuccess(ctrl);
          },
          onPreferenceError: function (err) {
            showNotificationPrefsError(ctrl, err);
          }
        })
      ]);
    }
  }
};



page.view = function () {
  var ctrl = this;
  if(!ctrl.user){
    return m('div')
  }
  
  var profileSections = {
    Profile: [profileWrap(userProfile, ctrl)],
    Password: [profileWrap(userPassword, ctrl)],
    Notifications: [groupsWrap(ctrl)]
  }

  if((ctrl.user.managedByAzure && ctrl.user.managedByAzure == '1') || (ctrl.user.managedByCloud && ctrl.user.managedByCloud == '1')){
    var profileSections = {
      Profile: [profileWrap(userProfile, ctrl)],
      Notifications: [groupsWrap(ctrl)]
    }
  }else{
    var profileSections = {
      Profile: [profileWrap(userProfile, ctrl)],
      Password: [profileWrap(userPassword, ctrl)],
      Notifications: [groupsWrap(ctrl)]
    }
  }
  if (false) {
    profileSections.Admin = [profileWrap(userAdmin)];
  }
  return m('div.container', [
    m(heading, {label:ctrl.user.firstName + ' ' + ctrl.user.lastName , class:'f2 mb3 pb2 display'}, []),
    m('div',[
      m(flash, {items: ctrl.successFlash(), bg: 'bg-green'}),
      ((ctrl.user.managedByAzure && ctrl.user.managedByAzure == '1') || (ctrl.user.managedByCloud && ctrl.user.managedByCloud == '1')) ?
        ''
      :
        m(flash, {items: ctrl.user.expiredPassword ? ['Password expired'] : [], bg: 'bg-red'})
    ]),
    m(tabs, {tabs:profileSections, onChange: () => clearProfileSuccessFlash(ctrl)})
  ]);
};

let saveProfile = function (form, ctrl){
  if(form.form.password){
    if(!form.form.password()){
      return form.save();
    }
    if(passwordPolicy.isStrongPassword(form.form.password())){
      return form.save()
      .then(res=>{
        showProfileSuccessFlash(ctrl, ['Profile updated']);
        ctrl.init();
      })
    }
    else{
      form.errors= [passwordPolicy.STRONG_PASSWORD_MESSAGE]
      m.redraw();
      return Promise.reject(form.errors);
    }
  }else{
    return form.save()
    .then(res=>{
      showProfileSuccessFlash(ctrl, ['Profile updated']);
      ctrl.init();
    })
  }
}

module.exports = page;
